module.exports = __webpack_public_path__ + "img/logo-of-consumer-electronics-show-svg@2x.10a6f7c9.png";